export function transformToBTC(value) {
    const sats = value / 1000;

    // if (sats < 60000) {
    //     const kSats = sats / 1000;
    //     // Format with at least 2 integer digits and up to 2 decimals.
    //     const formattedKSats = kSats.toLocaleString(undefined, {
    //         minimumIntegerDigits: 2,
    //         maximumFractionDigits: 2,
    //         useGrouping: false
    //     });
    //     return `${formattedKSats}k SATS`;
    // }
    // return value

    const btc = sats / 100000000;
    if (Math.abs(btc) < 0.00001) {
        // If the value is less than 0.00001 BTC, return it in Satoshis
        const formattedSats = Math.round(sats);
        if (formattedSats <= 0) {
            return `${ sats } SATS`;
        }
        return `${ formattedSats } SATS`;
    }
    return `${ parseFloat(btc.toFixed(5)) } BTC`;
}

export function formatTokenAmount(n) {
    // Divide by 1e11
    n = n / 1e11;
    // return n

    // Determine the appropriate suffix
    if (n >= 1e9) {
        return (n / 1e9).toFixed(2) + "B";
    } else if (n >= 1e6) {
        return (n / 1e6).toFixed(2) + "M";
    } else if (n >= 1e3) {
        return (n / 1e3).toFixed(2) + "K";
    } else {
        return n.toFixed(2)>0? n.toFixed(2) : n;
    }
}

export const getStarsFromRating = (rating) => {
    switch (rating?.toLowerCase()) {
        case 'excellent': return 5;
        case 'good': return 4;
        case 'average': return 3;
        case 'low': return 2;
        default: return 1;
    }
};

// Time formatting utility function
export const timeAgo = (dateString, t) => {
    if (!dateString) return 'N/A';

    // Handle different date formats
    let date;
    if (typeof dateString === 'number') {
        // Unix timestamp (seconds)
        date = new Date(dateString * 1000);
    } else if (typeof dateString === 'string') {
        // ISO string or other string format
        date = new Date(dateString);
    } else {
        return 'N/A';
    }

    // Check if date is valid
    if (isNaN(date.getTime())) return 'N/A';

    const now = new Date();
    const seconds = Math.round((now - date) / 1000);

    // Allow for small negative values (clock skew)
    if (isNaN(seconds) || seconds < -60) return 'N/A';

    const absSeconds = Math.abs(seconds);
    const minutes = Math.round(absSeconds / 60);

    if (minutes < 1) {
        return t('time.justNow');
    }
    if (minutes === 1) {
        return t('time.aMin');
    }
    if (minutes < 60) {
        const translated = t('time.mins', { count: minutes });
        return translated.includes('{count}') ? translated.replace('{count}', minutes) : translated;
    }

    const hours = Math.round(minutes / 60);
    if (hours === 1) {
        return t('time.anHour');
    }
    if (hours < 24) {
        const translated = t('time.hours', { count: hours });
        return translated.includes('{count}') ? translated.replace('{count}', hours) : translated;
    }

    const days = Math.round(hours / 24);
    if (days === 1) {
        return t('time.aDay');
    }
    if (days < 30) {
        const translated = t('time.days', { count: days });
        return translated.includes('{count}') ? translated.replace('{count}', days) : translated;
    }

    const months = Math.round(days / 30);
    if (months === 1) {
        return t('time.aMonth');
    }
    if (months < 12) {
        const translated = t('time.months', { count: months });
        return translated.includes('{count}') ? translated.replace('{count}', months) : translated;
    }

    const years = Math.round(months / 12);
    if (years === 1) {
        return t('time.aYear');
    }
    const translated = t('time.years', { count: years });
    return translated.includes('{count}') ? translated.replace('{count}', years) : translated;
};
